import socialBlog from '@images/social-blog.png'
import socialPinterest from '@images/social-pinterest.png'
import socialTwitter from '@images/social-twitter.png'
import socialFacebook from '@images/social-facebook.png'
import socialYoutube from '@images/social-youtube.png'
import Component from '@glimmer/component'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { t } from 'ember-intl'

const urls: Partial<Record<SubscriptionType, Record<string, any>>> = {
  reading: {
    youtube: {
      default: 'https://www.youtube.com/user/ABCReadingEggs',
      KR: 'https://www.youtube.com/channel/UChGNn8wASixMGzcr0u7qSIg',
    },
    facebook: {
      default: 'https://www.facebook.com/readingeggs',
      KR: 'https://www.facebook.com/abceggskorea',
    },
    twitter: 'https://twitter.com/readingeggs',
    pinterest: 'https://www.pinterest.com.au/readingeggs',
  },
  maths: {
    youtube: {
      default: 'https://www.youtube.com/user/ABCReadingEggs',
      KR: 'https://www.youtube.com/channel/UChGNn8wASixMGzcr0u7qSIg',
    },
    facebook: {
      default: 'https://www.facebook.com/mathseeds',
    },
    twitter: 'https://twitter.com/mathseeds',
    pinterest: 'https://www.pinterest.com.au/mathseeds',
  },
}

interface Signature {
  Args: {
    countryCode: string
    subscriptionType: SubscriptionType.Reading | SubscriptionType.Maths
  }
}

export class SocialLinks extends Component<Signature> {
  get youtubeUrl() {
    return (
      urls[this.args.subscriptionType]?.youtube?.[this.args.countryCode] ??
      urls[this.args.subscriptionType]?.youtube.default
    )
  }

  get facebookUrl() {
    return (
      urls[this.args.subscriptionType]?.facebook?.[this.args.countryCode] ??
      urls[this.args.subscriptionType]?.facebook.default
    )
  }

  get twitterUrl() {
    return urls[this.args.subscriptionType]?.twitter
  }

  get pinterestUrl() {
    return urls[this.args.subscriptionType]?.pinterest
  }

  get youtubeLogo() {
    return socialYoutube
  }
  get facebookLogo() {
    return socialFacebook
  }
  get twitterLogo() {
    return socialTwitter
  }
  get pinterestLogo() {
    return socialPinterest
  }
  get socialBlogLogo() {
    return socialBlog
  }

  <template>
    <div class="flex justify-end">
      <a
        data-test-youtube
        href={{this.youtubeUrl}}
        title={{t "components.footerMain.imageLinks.youtube"}}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={{this.youtubeLogo}} alt={{t "components.footerMain.imageLinks.youtube"}} />
      </a>
      <a
        data-test-facebook
        href={{this.facebookUrl}}
        title={{t "components.footerMain.imageLinks.facebook"}}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={{this.facebookLogo}} alt={{t "components.footerMain.imageLinks.facebook"}} />
      </a>
      <a
        data-test-twitter
        href={{this.twitterUrl}}
        title={{t "components.footerMain.imageLinks.twitter"}}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={{this.twitterLogo}} alt={{t "components.footerMain.imageLinks.twitter"}} />
      </a>
      <a
        data-test-pinterest
        href={{this.pinterestUrl}}
        title={{t "components.footerMain.imageLinks.pinterest"}}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={{this.pinterestLogo}} alt={{t "components.footerMain.imageLinks.pinterest"}} />
      </a>
      <a
        data-test-wordpress
        href="https://blog.readingeggs.com"
        title={{t "components.footerMain.imageLinks.wordpress"}}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={{this.socialBlogLogo}} alt={{t "components.footerMain.imageLinks.wordpress"}} />
      </a>
    </div>
  </template>
}

export default SocialLinks
